import env from 'env-var'

const config = Object.freeze({
  baseURL: env.get('REACT_APP_IBGE').asUrlString()
})

export default config
